import { ref } from 'vue';
import { generateHtmlFromDiff, convertEditableDomToText, normalizeTextForDiff, removeEmptyLinesAtEnd } from '../utils/helper';
import axios from 'axios';
export const usePreviewModal = () => {
    const isOpen = ref(false);
    const lastDiff = ref([]);
    const openPreviewModal = (inputTextId, beforeHtmlId, afterHtmlId) => {
        const inputArea = document.getElementById(inputTextId);
        if (!inputArea)
            throw new Error('Element not found');
        const storedInputText = sessionStorage.getItem('proofTexts');
        const placeholder = inputArea.getElementsByClassName('placeholder')[0];
        let text = inputArea.innerText;
        if (placeholder)
            text = text.replace(placeholder.innerText, '');
        if (storedInputText == null) {
            alert('校正前のテキストがありません。');
            return;
        }
        const currentText = removeEmptyLinesAtEnd(convertEditableDomToText(inputArea));
        const beforeText = removeEmptyLinesAtEnd(storedInputText);
        const escapeHtml = (str) => str.replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
        const normalizedBefore = normalizeTextForDiff(beforeText);
        const normalizedAfter = normalizeTextForDiff(currentText);
        const { beforeHtml, afterHtml, diff } = generateHtmlFromDiff(escapeHtml(normalizedBefore), escapeHtml(normalizedAfter));
        lastDiff.value = diff;
        const beforeHtmlElement = document.getElementById(beforeHtmlId);
        const afterHtmlElement = document.getElementById(afterHtmlId);
        if (!beforeHtmlElement || !afterHtmlElement)
            throw new Error('Element not found');
        beforeHtmlElement.innerHTML = beforeHtml;
        afterHtmlElement.innerHTML = afterHtml;
        isOpen.value = true;
    };
    const closePreviewModal = () => {
        isOpen.value = false;
    };
    // プレビューエクスポート
    const exportDocx = async (exportUrl) => {
        let url = null;
        try {
            // ★追加：エスケープされた文字を元の記号に戻す関数（アンエスケープ）
            const unescapeHtml = (str) => str.replace(/&amp;/g, '&')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'");
            // ★追加：APIへ送る直前に、diffデータの中身だけ元の文字列に戻す
            const rawDiff = lastDiff.value.map(([op, text]) => [op, unescapeHtml(text)]);
            // ★修正：lastDiff.value ではなく、元に戻した rawDiff を送信する
            const res = await axios.post(exportUrl, { diff: rawDiff }, { responseType: 'blob' });
            // const res = await axios.post(exportUrl, { diff: lastDiff.value }, { responseType: 'blob' });
            const fileName = res.headers['content-disposition'].split('filename=')[1];
            const blob = new Blob([res.data], {
                type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            });
            url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            document.body.appendChild(a);
            a.download = fileName;
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        }
        catch (e) {
            console.log('Preview export error:', e);
            alert('書き出しに失敗しました。');
        }
        finally {
            if (url)
                window.URL.revokeObjectURL(url);
        }
    };
    return {
        isOpen,
        openPreviewModal,
        closePreviewModal,
        exportDocx,
    };
};
